import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { PageHeader, Panel, SortableList } from "./ui";
import { useSettingsDraft } from "./settingsDraft";

export default function ShippingPage() {
  const { d, setIn, SaveBtn } = useSettingsDraft();
  if (!d) return null;
  const s = d.shipping || {};
  const set = (k, v) => setIn("shipping", k, v);
  const zones = s.zones || [];
  const upd = (i, k, v) => set("zones", zones.map((z, j) => (j === i ? { ...z, [k]: v } : z)));
  return (
    <div data-testid="admin-shipping-page">
      <PageHeader title="Envíos y entregas" subtitle="Tarifas y zonas que el cliente elige en el checkout" actions={SaveBtn} />
      <div className="space-y-6">
        <Panel title="Zonas de cobertura y tarifas">
          <SortableList items={zones.map((z, i) => ({ ...z, _k: z.id || `z${i}` }))} getId={(z) => z._k} onReorder={(l) => set("zones", l.map(({ _k, ...z }) => z))}
            renderItem={(z, i) => (
              <div className="grid grid-cols-12 gap-2 bg-neutral-50 rounded-xl p-2" data-testid={`zone-${i}`}>
                <Input className="col-span-12 sm:col-span-4" placeholder="Destino / zona" value={z.name || ""} onChange={(e) => upd(i, "name", e.target.value)} data-testid={`zone-name-${i}`} />
                <Input className="col-span-4 sm:col-span-2" type="number" step="0.01" placeholder="S/" value={z.cost ?? 0} onChange={(e) => upd(i, "cost", Number(e.target.value))} data-testid={`zone-cost-${i}`} />
                <Input className="col-span-6 sm:col-span-5" placeholder="Nota (tiempo, condiciones)" value={z.note || ""} onChange={(e) => upd(i, "note", e.target.value)} />
                <Button variant="outline" size="icon" className="col-span-2 sm:col-span-1" onClick={() => set("zones", zones.filter((_, j) => j !== i))}><Trash2 size={14} /></Button>
              </div>
            )} />
          <Button size="sm" variant="outline" className="mt-3" onClick={() => set("zones", [...zones, { id: `zona-${Date.now().toString(36)}`, name: "", cost: 0, note: "" }])} data-testid="add-zone"><Plus size={14} className="mr-1" /> Agregar zona</Button>
          <p className="text-xs text-neutral-500 mt-2">Tip: usa el nombre "Provincia" para mostrar las indicaciones de provincia al cliente.</p>
        </Panel>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Panel title="Recojo en tienda">
            <div className="flex items-center gap-2 mb-4"><Switch checked={!!s.pickup_enabled} onCheckedChange={(v) => set("pickup_enabled", v)} data-testid="pickup-enabled" /><span className="text-sm font-semibold">Permitir recojo en tienda</span></div>
            <div className="space-y-3">
              <div><Label>Dirección de recojo</Label><Input value={s.pickup_address || ""} onChange={(e) => set("pickup_address", e.target.value)} /></div>
              <div><Label>Indicaciones de recojo</Label><Textarea rows={2} value={s.pickup_note || ""} onChange={(e) => set("pickup_note", e.target.value)} /></div>
            </div>
          </Panel>
          <Panel title="Provincia y condiciones">
            <div className="space-y-3">
              <div><Label>Indicaciones para envíos a provincia</Label><Textarea rows={3} value={s.province_instructions || ""} onChange={(e) => set("province_instructions", e.target.value)} data-testid="province-instructions" /></div>
              <div><Label>Condiciones de entrega</Label><Textarea rows={3} value={s.delivery_conditions || ""} onChange={(e) => set("delivery_conditions", e.target.value)} /></div>
            </div>
          </Panel>
        </div>
      </div>
    </div>
  );
}
